import React, { useEffect } from 'react';
import { List, Icon, Box } from '@mui/material';
import { withRouter } from 'react-router-dom';
import DocumentListItem from './listitem';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import { get } from 'global/lib/lodash';
import { StyledCloseIconButton } from './styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { Loader, useScreen } from 'global/styles';
import { ListItem } from '../CourseList/listitem';
import { Row } from 'global/components/row';
import { TransformDocs } from '../courseShared';
import CopyrightNotice from 'global/components/PageFooter';

const include = ['edition', 'edition.documents', 'edition.documents.document', 'edition.documents.superset', 'edition.documents.reads', 'assessment', 'user'].join(',');

// Re-export shared helpers so existing `from '../CourseEditionList'` imports keep working.
export { sortDocs, TransformDocs } from '../courseShared';

export const CourseEditionList = withRouter((props) => {
  const { isDocumentPath } = props;
  const libid = get(props, 'match.params.id', 0);
  const { isMobile } = useScreen();
  // Compact chrome only on desktop sidebar; mobile keeps full list while sliding.
  const isSidebar = !!isDocumentPath && !isMobile;

  const locationProps = get(props, 'location.state', {});

  const ed = useRetrieveData(
    { url: `/course-assignments/${libid}` },
    {
      build: ['courseAssignments'],
      params: {
        include,
        filter: {
          role: locationProps.isReview ? 'reviewer' : undefined,
        },
      },
      transformData: TransformDocs,
    }
  );

  useEffect(() => {
    window.CourseEditionUpdate = ed.update;

    return () => {
      delete window.CourseEditionUpdate;
    };
  }, []);

  const onClose = () => {
    const { fromLibrary } = locationProps;
    if (fromLibrary) {
      props.history.push('/library', locationProps);
    } else {
      props.history.push('/courses', locationProps);
    }
  };

  return (
    // Full-width scroll host (same as DocumentList) so the scrollbar sits on the
    // panel edge; center/maxWidth only constrains the content inside.
    <Box sx={{ height: '100%', width: '100%', overflow: 'auto', boxSizing: 'border-box' }}>
      <Box
        sx={(theme) => ({
          boxSizing: 'border-box',
          ...(isSidebar
            ? { pt: 2 }
            : {
                maxWidth: theme.breakpoints.values.content,
                mx: 'auto',
              }),
        })}
      >
        <Row fullWidth>
          <StyledCloseIconButton onClick={onClose} size="large">
            <Icon>chevron_left</Icon>
          </StyledCloseIconButton>
          {ed.loading ? <Loader size={30} /> : <ListItem item={ed.data} disabled isMobile={isSidebar} showSecondRow={!isSidebar} />}
        </Row>

        <ScrollList loading={ed.loading} data={get(ed, 'data.edition._documents', [])} alwaysReplaceData={true} />
        {!isSidebar && <CopyrightNotice ownerRealmId={get(ed, 'data.edition.ownerRealmId')} />}
      </Box>
    </Box>
  );
});

const ScrollList = withInfiniteScroll(DocumentListItem, List);
